import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_Tsq = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_Tsq' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Trauma Screening Questionnaire (TSQ)</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>If you have recently been exposed to a potentially traumatic event
                            (a PTE), here is a tool that may help you to identify whether or not you
                            should seek additional help in recovering from its effects. Have you
                            recently experienced any of the following:</span></td>
                        <td className='w-100'><center><span className='eleHeader'><b>YES</b> <br />at least twice in the past week</span></center></td>
                        <td className='w-100'><center><span className='eleHeader'><b>NO</b><br />&nbsp; <br />&nbsp;<br />&nbsp;</span></center></td>
                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-550'>1. Upsetting thoughts or memories about the event that have come into your mind against your will</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbUpsettingThoughtsOrMemories_1' name='rbUpsettingThoughtsOrMemories' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbUpsettingThoughtsOrMemories_2' name='rbUpsettingThoughtsOrMemories' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>2. Upsetting dreams about the event</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbUpsettingDreamsAboutEvent_1' name='rbUpsettingDreamsAboutEvent' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbUpsettingDreamsAboutEvent_2' name='rbUpsettingDreamsAboutEvent' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>3. Acting or feeling as though the event were happening again</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbActingOrFeelingAsThoughEvent_1' name='rbActingOrFeelingAsThoughEvent' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbActingOrFeelingAsThoughEvent_2' name='rbActingOrFeelingAsThoughEvent' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>4. Feeling upset by reminders of the event</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingUpsetRemindersEvent_1' name='rbFeelingUpsetRemindersEvent' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingUpsetRemindersEvent_2' name='rbFeelingUpsetRemindersEvent' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>5. Bodily reactions (such as fast heartbeat, stomach churning)</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBodilyReactionsSuchAsFast_1' name='rbBodilyReactionsSuchAsFast' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbBodilyReactionsSuchAsFast_2' name='rbBodilyReactionsSuchAsFast' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>6. Difficulty falling or staying asleep</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDifficultyFallingStaying_1' name='rbDifficultyFallingStaying' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDifficultyFallingStaying_2' name='rbDifficultyFallingStaying' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>7. Irritability or outbursts of anger</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritabilityOrOutburstsAnger_1' name='rbIrritabilityOrOutburstsAnger' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbIrritabilityOrOutburstsAnger_2' name='rbIrritabilityOrOutburstsAnger' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>8. Difficulty concentrating</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDifficultyConcentrating_1' name='rbDifficultyConcentrating' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDifficultyConcentrating_2' name='rbDifficultyConcentrating' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>9. Heightened awareness of potential dangers to yourself and others</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHeightenedAwarnessPotentialDangers_1' name='rbHeightenedAwarnessPotentialDangers' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHeightenedAwarnessPotentialDangers_2' name='rbHeightenedAwarnessPotentialDangers' className='add-only' value='2' /></center></td>
                    </tr>

                    <tr>
                        <td className='w-550'>10. Feeling jumpy or being startled by something unexpected</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingJumpBeingStartedBySomething_1' name='rbFeelingJumpBeingStartedBySomething' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingJumpBeingStartedBySomething_2' name='rbFeelingJumpBeingStartedBySomething' className='add-only' value='2' /></center></td>
                    </tr>
                </table>

                <p className='w-750'><center><span className='small'>It is recommended that the TSQ be offered 3-4 weeks post-trauma, to allow time
                    for normal recovery processes to take place. If at that point an individual has 6
                    or more YES answers, a referral to a behavioral health practitioner is indicated. <br />C. R. Brewin, et al, 2002. (Used by permission)</span></center>
                </p>









            </div>
        </form>

    )
}   